require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-len-warson-glenvill-ceo-chairman-talks-to-alan.json") })
        }
      }, "path---news-len-warson-glenvill-ceo-chairman-talks-to-alan");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-len-warson-glenvill-ceo-chairman-talks-to-alan!./.cache/json/news-len-warson-glenvill-ceo-chairman-talks-to-alan.json
// module id = 825
// module chunks = 231608221292675